import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setDependentesDoAGSUS(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const visibleDependent2 = false
  const visibleDependent3 = false
  const visibleDependent4 = false

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const seuExameAdmissionalFoiRealizadoPelaClinicaCredenciadaOuParticular = watch(
    `form_answers.${titleForQuestion['Seu exame admissional foi realizado pela Clínica credenciada ou particular?']}`
  )
  const possuiContaCorrenteOuContaSalarioNoBancoDoBrasil = watch(
    `form_answers.${titleForQuestion['Possui conta corrente ou conta salário no Banco do Brasil?']}`
  )

  const possuiCTPSDigital = watch(`form_answers.${titleForQuestion['Possui CTPS Digital?']}`)

  const possuiDependente = watch(`form_answers.${titleForQuestion['Possui dependente?']}`)

  const filteredQuestions = questions.filter((question) => {
    const questionAboutDependent = question.title?.includes('Dependente')
    const match = question.title?.match(/Dependente (\d+) -/)
    let number = null

    if (questionAboutDependent) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    if (number == 1 && possuiDependente != 'Sim') {
      return false
    }

    if (number == 2 && !visibleDependent2) {
      return false
    }

    if (number == 3 && !visibleDependent3) {
      return false
    }

    if (number == 4 && !visibleDependent4) {
      return false
    }

    //QUESTÃO 9
    if (question.title == 'Campo de upload para Recibo de Pagamento') {
      if (seuExameAdmissionalFoiRealizadoPelaClinicaCredenciadaOuParticular == 'Particular') {
        return true
      } else {
        return false
      }
    }

    //QUESTÃO 11
    if (question.title == 'Possui chave PIX vinculada ao CPF?') {
      return true
    }

    //QUESTÃO 12
    if (question.title == 'Gostaria que a Agência providencie a abertura de uma conta salário para você?') {
      if (possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Não') {
        return true
      } else {
        return false
      }
    }

    //QUESTÃO 11
    if (question.title == 'Possui chave PIX vinculada ao CPF?') {
      return true
    }

    //QUESTÃO 12
    if (question.title == 'Gostaria que a Agência providencie a abertura de uma conta salário para você?') {
      if (possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Não') {
        return true
      } else {
        return false
      }
    }

    //QUESTÃO 12/13/14/15
    if (question.title == 'Agência' || question.title == 'Dígito' || question.title == 'Conta') {
      if (
        possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Corrente' ||
        possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Salário'
      ) {
        return true
      } else {
        return false
      }
    }

    //QUESTÃO 21
    if (question.title == 'CEP') {
      return true
    }

    //QUESTÃO 43/44/45/46
    if (
      question.title == 'CTPS - Número' ||
      question.title == 'CTPS - UF' ||
      question.title == 'CTPS - Data de emissão' ||
      question.title == 'CTPS - Série'
    ) {
      if (possuiCTPSDigital == 'Não') {
        return true
      } else {
        return false
      }
    }

    return true
  })

  return filteredQuestions
}
